import { toast } from 'react-toastify'
import ClubService from 'Services/club'
import CustomLinkService from 'Services/customlinks'
import UploadService from 'Services/upload'
import { updateClubs } from 'Store/clubs'

import * as convert from 'xml-js'

/* This should be called anytime the cloned client is created. This updates its
custom links to reflect the club id that was just created */
const updateCustomLinks = async ({ id, customLinks }) => {
  customLinks.forEach(async link => {
    const newLink = { ...link, clubimpact_id: id }
    // Update the custom link to reflect the club id that was just created
    await CustomLinkService.update({ id: link.id, data: newLink })
  })
}

const onSubmit = async (e, selectedClub, previewImages, setSelectedClub, setClub) => {
  const clubData = selectedClub

  e.preventDefault()

  // Check for a valid app code
  if (clubData.clubId === '') return toast.error('Please enter a valid app id')

  // Upload logo
  if (previewImages.imageHeader?.file) {
    const formData7 = new FormData()
    formData7.append('previewImagesHeader', previewImages?.imageHeader.file)
    formData7.append(
      'previewImagesName',
      `${clubData.clubId}-${previewImages?.imageHeader?.file.name.replace(/-/g, '')}`
    )
    try {
      await UploadService.uploadHeader({ formData: formData7 })
    } catch (err) {
      toast.error(`Something went wrong when trying to upload the logo image: ${err.message}`)
      return
    }
  }

  if (previewImages.image1?.file) {
    const formData1 = new FormData()
    formData1.append('resource', previewImages.image1.file)
    formData1.append(
      'previewImagesName',
      `${clubData.clubId}-${previewImages?.image1.file.name.replace(/-/g, '')}`
    )
    try {
      await UploadService.uploadResource({ formData: formData1 })
    } catch (err) {
      toast.error(`Something went wrong when trying to upload resource image #1: ${err.message}`)
      return
    }
  }

  if (previewImages.image2?.file) {
    const formData2 = new FormData()
    formData2.append('resource', previewImages.image2.file)
    formData2.append(
      'previewImagesName',
      `${clubData.clubId}-${previewImages?.image2?.file.name.replace(/-/g, '')}`
    )
    try {
      await UploadService.uploadResource({ formData: formData2 })
    } catch (err) {
      toast.error(`Something went wrong while trying to upload resource image #2: ${err.message}`)
      return
    }
  }

  if (previewImages.image3?.file) {
    const formData3 = new FormData()
    formData3.append('resource', previewImages.image3.file)
    formData3.append(
      'previewImagesName',
      `${clubData.clubId}-${previewImages?.image3?.file.name.replace(/-/g, '')}`
    )
    try {
      await UploadService.uploadResource({ formData: formData3 })
    } catch (err) {
      toast.error(`Something went wrong while trying to upload resource image #3: ${err.message}`)
      return
    }
  }

  if (previewImages.image4?.file) {
    const formData4 = new FormData()
    formData4.append('resource', previewImages.image4.file)
    formData4.append(
      'previewImagesName',
      `${clubData.clubId}-${previewImages?.image4?.file.name.replace(/-/g, '')}`
    )
    try {
      await UploadService.uploadResource({ formData: formData4 })
    } catch (err) {
      toast.error(`Something went wrong while trying to upload resource image #4: ${err.message}`)
      return
    }
  }

  if (previewImages.image5?.file) {
    const formData5 = new FormData()
    formData5.append('resource', previewImages.image5.file)
    formData5.append(
      'previewImagesName',
      `${clubData.clubId}-${previewImages?.image5?.file.name.replace(/-/g, '')}`
    )
    try {
      await UploadService.uploadResource({ formData: formData5 })
    } catch (err) {
      toast.error(`Something went wrong while trying to upload resource image #5: ${err.message}`)
      return
    }
  }

  if (previewImages.image6?.file) {
    const formData6 = new FormData()
    formData6.append('resource', previewImages.image6.file)
    formData6.append(
      'previewImagesName',
      `${clubData.clubId}-${previewImages?.image6?.file.name.replace(/-/g, '')}`
    )
    try {
      await UploadService.uploadResource({ formData: formData6 }).then(() => {})
    } catch (err) {
      toast.error(`Something went wrong while trying to upload resource image #6: ${err.message}`)
      return
    }
  }

  if (previewImages.image7?.file) {
    const formData7 = new FormData()
    formData7.append('resource', previewImages.image7.file)
    formData7.append(
      'previewImagesName',
      `${clubData.clubId}-${previewImages?.image7?.file.name.replace(/-/g, '')}`
    )
    try {
      await UploadService.uploadResource({ formData: formData7 }).then(() => {})
    } catch (err) {
      toast.error(`Something went wrong while trying to upload resource image #7: ${err.message}`)
      return
    }
  }

  const xml = convert.json2xml(JSON.stringify(clubData), {
    compact: true,
    ignoreComment: true,
    spaces: 4,
    ignoreAttributes: '<root>'
  })

  const data = {
    clubName: clubData.clubName,
    clubId: clubData.clubId,
    customLinks: clubData.customLinks,
    contentxml: xml
  }

  if (clubData?.cloned && !clubData?.alreadyCreated) {
    ClubService.create({ data }).then(async resp => {
      const club = resp.data
      await updateClubs()
      await updateCustomLinks({ id: club.id, customLinks: clubData.customLinks })
      setClub({ ...clubData, id: club.id, alreadyCreated: true })
      setSelectedClub({ ...clubData, id: club.id, alreadyCreated: true })
      toast.info('Client successfully saved.')
    })
  } else {
    ClubService.update({ id: clubData.id, data }).then(async () => {
      await updateClubs()
      toast.info('Client successfully updated.')
    })
  }
}

export default onSubmit
